export const abbreviateNumber = (num: number): string => {
  if (num) {
    if (num >= 1000000) {
      const rounded = Math.round(num / 100000) / 10;
      return (
        (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)) + "M"
      );
    } else if (num >= 1000) {
      const rounded = Math.round(num / 100) / 10;
      return (
        (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)) + "K"
      );
    } else {
      return num.toString();
    }
  } else {
    return "";
  }
};
